import styled from 'styled-components';
import { colors,  } from 'globalStyles';
import { media } from 'utils/style-utils';

export const Wrapper = styled.div``;

export const Title = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  color: ${colors.DARK};

  height: 33px;
  padding-bottom: 16px;
  box-sizing: content-box;
`;

export const Nav = styled.nav`
  display: flex;
  flex-wrap: wrap;
`;

export const Button = styled.ul`
  &.cancel {
    color: ${colors.MAIN_COLOR};
    cursor: pointer;
    font-size: 12px;
    font-family: poppins, sans-serif;
    font-weight: bold;
    line-height: 19px;
    margin-right: 20px;
    text-decoration: underline;
  }
`;
export const Ul = styled.ul`
  margin: 20px 0 0 0;
  padding: 0;

  ${ media.mobile`
    display: flex;
    flex-wrap: wrap;
    margin: 0px 19px;
    width: 100%;
    margin-top: 14px;
    padding: 0px;
  `}
`;

export const Li = styled.li`
  list-style-type: none;
  float: left;
  ${ media.mobile`
    margin-top: 26px;
    width: 33%;
    text-align: center;
  `}
`;

export const Tab = styled.div`
  display: block;
  cursor: pointer;
  margin: 0 2em;

  &:first-of-type {
    margin-left: 0;
  }
`;

export const TitleWrapper = styled.div`
  box-shadow: 0 2px 0 0 ${({ isActive }) => isActive ? colors.ACTIVE_COLOR : 'transparent'};
  padding: 0 0 0.5em 0;
`;

export const TabTitle = styled.p`
  background: ${({ isActive, mementoPlan }) => isActive && mementoPlan ? colors.BUTTON_BG : ''};
  color: ${({ isActive, mementoPlan }) => isActive && mementoPlan ? colors.WHITE : (isActive ? colors.DARK : '#91ADBA') };
  border: ${({ isActive, mementoPlan }) => isActive && mementoPlan ? colors.BORDER_NONE : ''};
  text-transform: uppercase;
  font-size: 10px;
  font-weight: normal;
  font-family: poppins, sans-serif;
  letter-spacing: 2px;
  line-height: 14px;
  height: 14px;
  margin: 0px;

  &.active,
  &:hover  {
    color: black;
  }
`;



// WEBPACK FOOTER //
// ./src/components/FormTabs/styledComponents.js